import React from 'react';
import MonthlyReferralsOverTimeChart from './MonthlyReferralsOverTimeChart';

export default function ReceivedReferralsOverTime({ startDate, endDate }) {
  return (
    <MonthlyReferralsOverTimeChart
      title="Received Referrals Over Time"
      subtitle="Monthly received referrals for the last 12 months"
      tooltipLabel="Received referrals"
      noteLabel="Current month bars are highlighted in green."
      endpointDirection="received"
      responseKey="monthly_received_referrals"
      startDate={startDate}
      endDate={endDate}
    />
  );
}
